"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceGroupFragmentDependencies = exports.sourceGroupFragment = void 0;
const sourceFragment_1 = require("./sourceFragment");
exports.sourceGroupFragment = `
fragment sourceGroupFragment on SourceGroup {
  id
  name
  sources {
    ...sourceFragment
  }
}
`.trim();
exports.sourceGroupFragmentDependencies = [
    ...sourceFragment_1.sourceFragmentDependencies,
    sourceFragment_1.sourceFragment,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic291cmNlR3JvdXBGcmFnbWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9mcmFnbWVudHMvc291cmNlR3JvdXBGcmFnbWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxxREFBOEU7QUFFakUsUUFBQSxtQkFBbUIsR0FBRzs7Ozs7Ozs7Q0FRbEMsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVJLFFBQUEsK0JBQStCLEdBQUc7SUFDN0MsR0FBRywyQ0FBMEI7SUFDN0IsK0JBQWM7Q0FDZixDQUFDIn0=